__turbopack_context__.v({
  "modalContent": "index-module__5drQ4G__modalContent",
  "modalMask": "index-module__5drQ4G__modalMask",
  "modalRoot": "index-module__5drQ4G__modalRoot",
});
